import { render, staticRenderFns } from "./nice-wizard-2.vue?vue&type=template&id=ad525ccc&scoped=true"
import script from "./nice-wizard-2.vue?vue&type=script&lang=js"
export * from "./nice-wizard-2.vue?vue&type=script&lang=js"
import style0 from "./nice-wizard-2.vue?vue&type=style&index=0&id=ad525ccc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad525ccc",
  null
  
)

export default component.exports